<template>
    <div class="ew-button-group">
        <slot></slot>
    </div>
</template>
<script setup></script>
<style lang="scss">
.ew-button-group {
    @apply tw-inline-flex;

    & > :nth-child(n) {
        @apply tw-rounded-none tw-border tw-border-r-0;
        & > button {
            @apply tw-rounded-none tw-border tw-border-r-0;
        }

        &:first-child,
        &:first-child > button {
            @apply tw-rounded-l;
        }
        &:last-child,
        &:last-child > button {
            @apply tw-rounded-r tw-border-x;
        }
    }
}
</style>
